import { render } from "./LegacyBeginOrderForm.vue?vue&type=template&id=1b72cfe0"
import script from "./LegacyBeginOrderForm.vue?vue&type=script&lang=js"
export * from "./LegacyBeginOrderForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__